import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { Col, Container, Row } from 'react-bootstrap'
import { Box, InnerHeading, MainHeading, SpanStyled } from '../../ui/Elements'
import { ArrowBtnBrown, ComMap, MBS, StatsBg1, StatsBg2, StatsBg3, StatsBg4, StripeBg, StripeBgAr, Vision, VisionAr, VisionBg, VisionBgAr } from '../../ui/AllImages'
import { useInView } from 'react-intersection-observer'
import { useTranslation } from 'react-i18next'
import { AboutBox } from '../../ui/CustomElements'
import i18n from '../../Languages/INEXT'
import { VisionMissionList } from '../projectData/Data'
import { Animate } from 'react-simple-animate'
import AboutCompany from './AboutCompany'
import AboutVision from './AboutVision'
const About = () => {
    const { t } = useTranslation()
    const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // When visible, set to true
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // run animation once
        }
      },
      {
        threshold: 0.2, // 20% of section visible triggers the animation
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);
    const start = { opacity: 0, transform: 'translateY(-40px)' };
    const end = { opacity: 1, transform: 'translateY(0)' };
    const start2 = { opacity: 0, transform: 'translateY(100px)' };
    const end2 = { opacity: 1, transform: 'translateY(0)' };
    return (
        <Box  id='about'>
            <AboutWapper className='container-fluid secAbout common-space'>
                <Container>
                    <Row className='about-row'>
                        <Col md={12} className='about-col-wrap about-leader-col-wrap' ref={sectionRef}>
                            <Row className='leaderRow'>
                                <Col md={12} className='leader-col leader-col-content' >
                                    <Animate
                                        play={isVisible}
                                        duration={1}
                                        start={start}
                                        end={end}
                                    >

                                    <MainHeading className='main-heading main-heading-leader mb-3' size="50px" color="var(--themeColor)">
                                        {t('aboutH1')}
                                    </MainHeading>
                                    </Animate>
                                    <Animate
                                            play={isVisible}
                                            duration={1}
                                            delay={.5}
                                            start={start}
                                            end={end}
                                        >
                                    <SpanStyled className='aboutLeaderText' color="var(--themeColor)">
                                        {t('aboutT1')}
                                        <br></br>
                                        <br></br>
                                        {t('aboutT2')}&nbsp;2030: {t('aboutT2_2')}
                                    </SpanStyled>
                                    </Animate>
                                </Col>
                                <Col md={12} className='leader-col leader-col-img'>
                                    <Box className='leader-col-img-box'>
                                        <Animate
                                            play={isVisible}
                                            duration={1}
                                            delay={1}
                                            start={start}
                                            end={end}
                                        >
                                        <img src={MBS} alt="mbs" />
                                        </Animate>
                                    </Box>
                                </Col>
                            </Row>
                        </Col>
                        {/* <Col md={12} className='about-col-wrap about-com-col-wrap'>
                            <Row className='aboutComRow'>
                                <Col lg={6} md={12} className='com-col com-col-img'>
                                <Animate
                                            play={isVisible}
                                            duration={1}
                                            delay={2}
                                            start={start}
                                            end={end}
                                        >
                                    <img src={ComMap} alt="map" />
                                    </Animate>
                                </Col>
                                <Col lg={6} md={12} className='about-com-col'>
                                <Animate
                                            play={isVisible}
                                            duration={1}
                                            delay={1}
                                            start={start}
                                            end={end}
                                        >
                                    <InnerHeading className='sub-heading sub-heading-about' color="var(--secondaryColor)">
                                        {t('aboutH2')}
                                    </InnerHeading>
                                    </Animate>
                                    <Animate
                                            play={isVisible}
                                            duration={1}
                                            delay={2}
                                            start={start}
                                            end={end}
                                        >
                                    <MainHeading className='main-heading main-heading-about' color="var(--themeColor)">
                                        {t('aboutH3')}
                                    </MainHeading>
                                    </Animate>
                                    <Animate
                                            play={isVisible}
                                            duration={1}
                                            delay={3}
                                            start={start}
                                            end={end}
                                        >
                                    <SpanStyled className='aboutComText mt-3' color="var(--themeColor)">
                                        {t('aboutT3')}&nbsp;<span className='engReg'>2030.</span>
                                    </SpanStyled>
                                    </Animate>
                                </Col>
                                
                            </Row>
                        </Col> */}
                        <AboutCompany />
                        <AboutVision />

                        
                        
                        
                    </Row>
                </Container>
                
            </AboutWapper>
            
        </Box>
    )
}
const AboutWapper = styled.section`
    padding-bottom: 0;
    .leaderRow, .aboutComRow, .aboutVisionRow{
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
    }
    .secAbout{
        overflow: hidden;
    }
    .leader-col-content{
        width: calc(100% - 360px);
        padding-right: 160px;
    }
    .aboutLeaderText{
        text-align: justify;
    }
    .leader-col-img{
        max-width: 360px;
        min-width: 360px;
        height: auto;
    }
    .leader-col-img-box{
        border-radius: 50px 0 50px 0;
        overflow: hidden;
    }
    .about-leader-col-wrap{
        padding-bottom: 100px;
    }
    .about-com-col-wrap{
        padding-bottom: 100px;
    }
    .visionMissionContent{
        display: flex;
        gap: 16px;
    }
    .visionMissionContentInner{
        display: flex;
        flex-direction: column;
    }
    .visionMissionContent:first-child{
        margin-bottom: 20px;
    }
    .vision-col-ctnt{
        padding-top: 20px;
    }
    .vision-col-img{
        display: flex;
        justify-content: center;
        position: relative;
        
        /* background: url(${VisionBg});
        background-repeat: no-repeat;
        background-position: left 0 bottom 0;
        background-size: 750px auto; */
    }
    .vision-col-img img{
        z-index: 5;
    }

    .vision-col-img img.visionSketch{
        position: absolute;
        bottom: 0;
        left: 10px;
        max-width: none;
        z-index: 4;
    }
    body.rtl &{
        .leader-col-content{
            padding-right: calc(var(--bs-gutter-x) * .5);
            padding-left: 160px;
        }
        .main-heading-leader{
            font-size: 60px;
        }
        .leader-col-img-box{
            border-radius: 0 50px 0 50px;
        }
        .main-heading-vis-mis{
            font-size: 40px;
        }
        .vision-col-img img.visionSketch{
            left: auto;
            right: 10px;
        }
    }
    @media (max-width: 1199px) {
        .leader-col-content{
            padding-right: calc(var(--bs-gutter-x) * .5);
        }
        body.rtl &{
            .leader-col-content{
                padding-right: calc(var(--bs-gutter-x) * .5);
                padding-left: calc(var(--bs-gutter-x) * .5);
            }
            
        }
        
    }
    @media (max-width: 991px) {
        padding-bottom: 90px;
        .leader-col-img{
            order: 1;
            display: flex;
            justify-content: center;
            margin-bottom: 25px;
        }
        .leader-col-content{
            width: 100%;
            padding-right: calc(var(--bs-gutter-x) * .5);
        }
        .leader-col-content{
            order: 2;
        }
        .leader-col-img-box{
            max-width: 336px;
            min-width: 336px;
        }
        .main-heading-leader{
            text-align: center;
            font-size: 40px;
        }
        .leader-col-img{
            max-width: 100%;
            min-width: 100%;
        }
        .aboutLeaderText{
            text-align: center;
        }
        .leaderRow, .aboutComRow{
            flex-wrap: wrap;
        }
        .com-col-img{
            display: flex;
            justify-content: center;
        }
        .main-heading-about{
            text-align: center;
        }
        .sub-heading-about{
            text-align: center;
            font-size: 30px;
        }
        .about-com-col{
            margin-top: 30px;
        }
        .aboutComText{
            text-align: center;
        }
        .aboutVisionRow{
            flex-wrap: wrap;
        }
        .vision-col-img{
            order: 1;
        }
        .vision-col-ctnt{
            order: 2;
            margin-top: 30px;
        }
        
        .vision-col-img img.visionSketch{
            right: 0;
            left: 0;
            margin: auto;
        }
        .visionMissionImg{
            display: none;
        }
        .main-heading-vis-mis{
            text-align: center;
        }
        .vis-mis-txt{
            text-align: center;
        }
        body.rtl &{
            .main-heading-leader{
                font-size: 50px;
            }
            .vision-col-img img.visionSketch{
                right: 0;
            left: 0;
            margin: auto;
            }
        }
        
    }
    @media (max-width: 767px) {
        
    }
    @media (max-width: 575px) {
        /* .main-heading-leader{
            font-size: 35px;
        } */
    }
`
export default About
